// Default font family
import "@fontsource/poppins";


import "./src/styles/theme.scss";

//require("prismjs/themes/prism-solarizedlight.css");
require("prismjs/themes/prism-coy.css");
